<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Versi Mobile Apps</div>
		</div>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listVersion" hide-default-footer class="table-w-50">
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom v-if="!edit">
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="update" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom v-if="edit">
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="saveData(item)" class="mr-1" fab dark x-small depressed color="green" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-check</v-icon>
							</v-btn>
						</template>
						<span>Simpan</span>
					</v-tooltip>
				</template>
				<template v-slot:item.version_minimum="{ item }">
					<v-text-field v-if="edit == true" clearable outlined dense hide-details v-model="item.version_minimum"></v-text-field>
					<span v-else>{{item.version_minimum}}</span>
				</template>
				<template v-slot:item.version_latest="{ item }">
					<v-text-field v-if="edit == true" clearable outlined dense hide-details v-model="item.version_latest"></v-text-field>
					<span v-else>{{item.version_latest}}</span>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationVersion">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			edit: '',
			headers: [
			{ text: 'Versi Minimum', value: 'version_minimum'},
			{ text: 'Versi Terbaru', value: 'version_latest'},
			{ text: 'Aksi', value: 'action'},
			],
		}
	},
	computed: {
		...mapState('mobileVersion', ['listVersion', 'paginationVersion']),
	},
	methods: {
		...mapActions('mobileVersion', ['getVersion', 'exportVersion', 'addVersion', 'updateVersion', 'deleteVersion']),
		...mapMutations('mobileVersion', ['clearDataVersion']),

		getData() {
			this.getVersion()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportVersion(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		update() {
			this.edit = true
		},
		async saveData(data) {
			await this.updateVersion({
				minimum: data.version_minimum,
				latest: data.version_latest
			})
			await this.getData()
			this.edit = await false
		},
	},
	beforeDestroy(){
		this.clearDataVersion()
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Version Ecommerce`)
		await this.getData()
	},
};
</script>

<style>
